import { render, staticRenderFns } from "./VuesticTag.vue?vue&type=template&id=bdac8368"
import script from "./VuesticTag.vue?vue&type=script&lang=js"
export * from "./VuesticTag.vue?vue&type=script&lang=js"
import style0 from "./VuesticTag.vue?vue&type=style&index=0&id=bdac8368&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdac8368')) {
      api.createRecord('bdac8368', component.options)
    } else {
      api.reload('bdac8368', component.options)
    }
    module.hot.accept("./VuesticTag.vue?vue&type=template&id=bdac8368", function () {
      api.rerender('bdac8368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-tag/VuesticTag.vue"
export default component.exports